/* src/app/pages/extra-pages/sign-in-1/sign-in-1.component.scss */
:host {
  background-size: cover;
  display: table-cell;
  height: 100%;
  vertical-align: middle;
  width: 100%;
}
:host card {
  margin: 0 auto;
  max-width: 400px;
}
:host card ::ng-deep .card-wrap {
  border: 0;
}
:host card form button {
  width: 100%;
}
:host card form .additional-info {
  background: rgba(0, 0, 0, 0.1);
  margin: 1.5714286rem -1.5714286rem -1.5714286rem;
  padding: 0.7857143rem 1.5714286rem;
}
:host card form .additional-info .divider {
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  display: inline-block;
  height: 18px;
  margin: 0 10px;
  vertical-align: bottom;
}
/*# sourceMappingURL=sign-in-1.component.css.map */
